import { useCurrentPublicCampaign } from '../campaign';
export const useExperiencePublicId = (id) => {
    const { experiences, loading } = useCurrentPublicCampaign();
    const experience = experiences === null || experiences === void 0 ? void 0 : experiences.find(experience => experience.id === id);
    return { experience, loading };
};
